(function($) {
    $(document).ready(function(){

		$header = $('.header');
		$offCanvas = $('.off-canvas');
		$offCanvas.on('opened.zf.offcanvas',function(){
			$header.addClass('with-menu-opened');
		});
		$offCanvas.on('closed.zf.offcanvas',function(){
			$header.removeClass('with-menu-opened');
		});

    });
})(jQuery);